/**
 * Best-effort 1x zoom lock for mobile browsers that expose `zoom` in MediaStreamTrack capabilities.
 * Many devices ignore this from the web layer — UI still warns "Do not use zoom".
 *
 * @param {MediaStream | null} stream
 * @returns {Promise<void>}
 */
export async function applyZoomLockTo1x(stream) {
  if (!stream) return;
  const track = stream.getVideoTracks()[0];
  if (!track || typeof track.getCapabilities !== 'function') return;
  try {
    const caps = track.getCapabilities();
    if (!caps || typeof caps.zoom !== 'object') return;
    const min = caps.zoom.min ?? 1;
    const max = caps.zoom.max ?? 1;
    const step = caps.zoom.step ?? 0.1;
    const target = Math.min(max, Math.max(min, 1));
    if (typeof track.applyConstraints === 'function') {
      await track.applyConstraints({ advanced: [{ zoom: target }] });
    }
  } catch {
    // Non-fatal: continue without zoom lock
  }
}
